import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router-dom';

class StepButton extends Component {

  render() {
    let button = null;
    // show the link if the step is applicable and anywhere in the workflow up to the first 'not started' step
    if (this.props.step.order <= this.props.notStartedStep.order) {
      /*
       * Only show the button as completed if every instance of the workflow step is completed.
       * For example, all sample collection steps for a multi-req order must be complete to show the step as complete.
       */
      const stepCompleted = this.props.steps.filter(step => step.id === this.props.step.id).every(step => step.completed);

      button = (
          <Link to={'/order/' + (this.props.match.params.id !== 0 ? this.props.match.params.id : 'new') + '/' + this.props.link
              + this.props.location.search} onClick={this.props.confirm}>
            <div className={'btn-arrow btn-arrow-right ' + (this.props.match.params.step === this.props.link ? 'btn-default' : 'btn-primary')}>
              <i className={'fa fa-fw ' + (stepCompleted ? 'fa-check' : this.props.iconClassName)}></i>
            </div>
          </Link>
      );
    } else {
      button = (
          <button className="btn-link" disabled={true} title={this.props.text + ' is not available yet.'}>
            <div className="btn-arrow btn-arrow-right btn-info disabled">
              <i className={'fa fa-fw ' + this.props.iconClassName}></i>
            </div>
          </button>
      );
    }

    return (
        <div className="col-sm-1 col-xs-2 step-button">
          <div className="row">
            {button}
          </div>
          <div className="row step-text">
            {this.props.text}
          </div>
        </div>
    );
  }
}

export default withRouter(StepButton);
